import React, {useEffect} from "react"
import { updateProduct } from "../../../store/products/actions"
import {
    Col,
    Row,
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Label,
    Input,
    Button,
} from "reactstrap"
import FieldValidation from "../../../components/Common/FieldValidation"

import { createProduct } from "../../../store/products/actions"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
function AddProductModal(props) {
    const { isEdit, modal, toggle, productData, setProductData, formErrors } =
        props
    const dispatch = useDispatch()
    const [isActive,setIsActive] = useState(productData?.is_active === 1) ;

    useEffect(() => {
        if (modal) {
            setIsActive(productData?.is_active === 1);
        }
    }, [modal]);

    const handleSubmit = e => {
        e.preventDefault()
        if (isEdit) {
            dispatch(
                updateProduct(
                    {
                        id: e.target.id.value,
                        name: e.target.name.value,
                        display_order: e.target.display_order.value,
                        is_active : isActive
                    },
                    toggle
                )
            )
        } else {
            // save new product
            dispatch(
                createProduct(
                    {
                        name: e.target.name.value,
                        display_order: e.target.display_order.value,
                        is_active : isActive
                    },
                    toggle
                )
            )
        }
    }
    return (
        <Modal isOpen={modal} toggle={toggle} centered>
            <ModalHeader toggle={toggle} tag="h4">
                {!!isEdit ? "Edit Product" : "Add New Product"}
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <input type={"hidden"} name="id" value={productData?.id}/>
                    <div className="mb-3">
                        <Label htmlFor="formrow-firstname-Input">Product Name</Label>
                        <Input
                            type="text"
                            className="form-control"
                            id="horizontal-product-name-Input"
                            placeholder="Enter Product Name"
                            name={"name"}
                            value={productData.name}
                            required
                            onChange={e => {
                                setProductData({
                                    id: productData.id,
                                    name: e.target.value,
                                })
                            }}
                        />
                        {formErrors?.name ? (
                            <FieldValidation errorMessage={formErrors?.name} />
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <Label htmlFor="formrow-firstname-Input">Display Order</Label>
                        <Input
                            type="number"
                            className="form-control"
                            id="horizontal-product-name-Input"
                            placeholder="Display Order"
                            name={"display_order"}
                            value={productData.display_order}
                            required
                            onChange={e => {
                                setProductData({
                                    display_order: e.target.value,
                                })
                            }}
                        />
                        {formErrors?.display_order ? (
                            <FieldValidation errorMessage={formErrors?.display_order} />
                        ) : null}
                    </div>
                    <div className="mb-3">
                        <Label htmlFor="formrow-firstname-Input">Status</Label>
                        <div className="form-check form-switch form-switch-md mb-3">

                            <input
                                type="checkbox"
                                name={"is_active"}
                                className="form-check-input"
                                id="change_status_switch1"
                                onChange={() => setIsActive(!isActive)}
                                checked={isActive}

                            />
                        </div>
                    </div>
                    <div className="text-end">
                        <Button type="submit" className="btn btn-success w-md">
                            Save
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default AddProductModal
